<!-- Pug Template -->
<template lang="pug">
.list-article
  .list-article__body
    template(
      v-if="index===0"
    )
      .list-article__body-content(
        v-html="introduction"
      )
    template(
      v-else
    )
      h2.list-article__heading {{item.index}}. {{item.title}}

      .list-article__body-content(
        v-html="item.content"
      )

      list-article-sponsors(
        :key="item.index"
        v-if="hasSponsors(item)"
        :introduction_text="item.sponsored_area.introduction_text"
        :sponsors="item.sponsored_area.sponsors"
      )
  
  .list-article__nav(
    v-if="next || prev"
  )
    
    a.list-article__nav-prev.btn.btn-lg.btn-back(
      v-if="prev"
      :href="prev.link"
      @click.prevent="nav(prev.index)"
    ) {{ `Previous: ${prev.title}` }}
    
    a.list-article__nav-next.btn.btn-lg.btn-success(
      v-if="next"
      :href="next.link"
      @click.prevent="nav(next.index)"
    ) {{ `Next: ${next.title}` }}

  list-article-toc(
    ref="toc"
    :items="items"
    :index="index"
    :permalink="permalink"
    :title="title"
    @index="i => index = i"
  )
  
</template>

<!-- Script -->
<script>
import ListArticleToc from './list-article-toc';
import ListArticleSponsors from './list-article-sponsors';
const $ = jQuery;
export default {
  name: 'ListArticle',
  components: { ListArticleToc, ListArticleSponsors },

  props : {
    config: {
      type: Object
    }
  },

  data(){
    this.config.items.forEach( item => {
      const a = document.createElement('a');
      a.href= item.permalink;
      item.pathname = a.pathname;
    });
    this.pages = [{
      title: 'Introduction',
      permalink: this.config.permalink,
      index: 0
    }];

    this.pages.push(...this.config.items);

    return {
      index: Number(this.config.index),
      introduction: this.config.introduction,
      items: this.config.items,
      permalink: this.config.permalink,
      title: this.config.title
    }
  },

  computed: {
    content(){
      if( this.index === 0 ){
        return this.introduction;
      }
      else {
        return this.items[this.index-1].content;
      }
    },
    item(){
      if( this.index === 0 ){
        return false;
      }
      else {
        return this.items[this.index-1];
      }
    },
    next(){
      if( this.index < this.pages.length ){
        return this.pages[this.index+1];
      }
      return false;
    },
    prev(){
      if( this.pages[this.index-1] ){
        return this.pages[this.index-1];
      }
      return false;
    }
  },

  watch: {
    index(v){
      const h = $('header').height();
      let scrollTop = 0;
      if( v > 0 ){
        scrollTop = $(this.$el).offset().top - $('body').offset().top - h - 20;
      }
      $('html,body').animate({scrollTop}, 300);

      // lets also log a page view..
      if( window.ga ){
        setTimeout( () => {
          if( window.dataLayer ){
            window.dataLayer.push({event:'pageview'});
          }
        }, 0);
      }
    }
  },

  mounted(){
    this.$refs.toc.$el;
    window.addEventListener('popstate', e => {
      const pathname = window.location.pathname;
      // find index
      const i = this.items.findIndex( item => item.pathname == pathname );
      this.index = i > -1 ? i+1 : 0;
    });
  },

  destroyed(){
    
  },

  methods: {
    hasSponsors(item){
      return item.sponsored_area && 
        item.sponsored_area.introduction_text && 
        item.sponsored_area.sponsors &&
        item.sponsored_area.sponsors.length;
    },
    nav(index){
      const link = this.$refs.toc.links[index];
      const a = document.createElement('a');

      a.href=link.permalink;
      window.history.pushState({index},'',a.pathname);
      this.index = index;
    }
  }
  
};
</script>

<!-- SCSS Style -->
<style lang="scss">
@import '../../../scss/front/variables'; 
.list-article {
  &__heading {
    font-size: 1.8rem;
    font-weight: 700;
    color: $color-warm-gray-11;
  }
  &__nav {
    margin: 1rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      margin: 0 0.5em;
      &-back {
        background: $color-warm-gray-8;
        color: #fff;
      }
    }
  }
}
</style>